<template>
  <div
    class="answer"
    :class="{ 'answer-bottom': datas.type != 'xuanze' || !chooseQuestionShow }"
    :style="{ height: getAnswerHeight(datas.current_question_style) }"
  >
    <!--选择题-->
    <div class="xuanze" v-show="datas.type === 'xuanze' && chooseQuestionShow">
      <div
        class="tk-item"
        :style="{
          fontSize: getMaxSize(datas.list) + 'px',
          animationDelay: index * 0.1 + 's',
          color: getFontColor(datas.current_question_style),
          height: getHeight(datas.current_question_style),
          background: background,
        }"
        :class="[
          a_on_off ? 'zoomIn' : 'zoomOut',
          'content',
          clickIndex == index ? 'active' : '',
          'content' + (index + 1),
          datas.list && datas.list.length == 2 && index == 0 ? 'aaa' : '',
          datas.list && datas.list.length == 2 && index == 1 ? 'bbb' : '',
        ]"
        @mouseover="questionOver(datas.current_question_style, index)"
        @mouseleave="questionLeave(datas.current_question_style, index)"
        ref="xuanze"
        :key="datas.desc.quick_question_id + (index + 1) * 20"
        @click="dati_xz(index)"
        v-for="(item, index) in datas.list"
      >
        <div
          v-for="(item1, index1) in item"
          :key="datas.desc.quick_question_id + index1"
          class="list-item"
        >
          <div class="txt" v-if="item1.type == 0">{{ item1.value[0] }}</div>
          <div class="genhao" v-if="item1.type == 2">
            <span class="kaifang">{{ item1.value[0] }}</span>
            <span class="beikaifang" :style="{ background: radicalBg }">{{
              item1.value[1]
            }}</span>
          </div>
          <div class="pingfang" v-if="item1.type == 3">
            <span class="dishu">{{ item1.value[0] }}</span>
            <span
              :style="{
                fontSize: calculatefontSize(item) == 30 ? '18px' : '14px',
              }"
              class="mi"
              >{{ item1.value[1] }}</span
            >
          </div>
          <div class="fenshu" v-if="item1.type == 1">
            <div class="zhengshu">{{ item1.value[2] }}</div>
            <div class="fenshi">
              <span class="fenzi">{{ item1.value[0] }}</span>
              <p
                class="line"
                :style="{
                  background: getFontColor(datas.current_question_style),
                }"
              ></p>
              <span class="fenmu">{{ item1.value[1] }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tk-item"
        v-if="datas.list && datas.list.length == 3"
        :style="{
          fontSize: getMaxSize(datas.list) + 'px',
          color: getFontColor(datas.current_question_style),
          height: getHeight(datas.current_question_style),
          background: background,
          opacity: '0',
        }"
        :class="[a_on_off ? 'zoomIn' : 'zoomOut', 'content']"
        ref="xuanze"
      ></div>
    </div>
    <!--填空题-->
    <div
      :class="['tiankong']"
      v-show="datas.type == 'tiankong' && questionShow"
    >
      <div
        class="content_end"
        v-for="(item, index) in datas.left"
        :key="datas.desc.quick_question_id + index"
      >
        <div class="txt" v-if="item.type == 0">{{ item.value[0] }}</div>
        <div class="genhao" v-if="item.type == 2">
          <span class="kaifang">{{ item.value[0] }}</span>
          <span class="beikaifang">{{ item.value[1] }}</span>
        </div>
        <div class="pingfang" v-if="item.type == 3">
          <span class="dishu">{{ item.value[0] }}</span>
          <span class="mi">{{ item.value[1] }}</span>
        </div>
        <div class="fenshu" v-if="item.type == 1">
          <div class="zhengshu">{{ item.value[2] }}</div>
          <div class="fenshi">
            <span class="fenzi">{{ item.value[0] }}</span>
            <p class="line"></p>
            <span class="fenmu">{{ item.value[1] }}</span>
          </div>
        </div>
      </div>
      <div class="content_middle" @click="dati_tk()" v-if="value">
        <div
          v-if="!k_on_off && !value.list[0] && !value.list[1]"
          class="default-txt"
        >
          点击答题
        </div>
        <div class="txt" v-else-if="value.type == 'number'">
          {{ value.list[0] }}
        </div>
        <div v-else-if="value.type == 'genhao'" class="genhao">
          <!-- <span class="kaifang"></span> -->
          <span class="beikaifang">{{ value.list[0] }}</span>
        </div>
        <div v-else-if="value.type == 'pingfang'" class="pingfang">
          <span class="dishu">{{ value.list[0] }} </span>
          <span class="mi">{{ value.list[1] }}</span>
        </div>
        <div v-else-if="value.type == 'fenshu'" class="fenshu">
          <div class="zhengshu">{{ value.list[2] }}</div>
          <div class="fenshi">
            <span class="fenzi">{{ value.list[0] }}</span>
            <p class="line"></p>
            <span class="fenmu">{{ value.list[1] }}</span>
          </div>
        </div>
      </div>
      <div
        class="content_end"
        v-for="(item, index) in datas.right"
        :key="datas.desc.quick_question_id + (index + 1) * 20"
      >
        <div class="txt" v-if="item.type == 0">{{ item.value[0] }}</div>
        <div class="genhao" v-if="item.type == 2">
          <span class="kaifang">{{ item.value[0] }}</span>
          <span class="beikaifang">{{ item.value[1] }}</span>
        </div>
        <div class="pingfang" v-if="item.type == 3">
          <span class="dishu">{{ item.value[0] }}</span>
          <span class="mi">{{ item.value[1] }}</span>
        </div>
        <div class="fenshu" v-if="item.type == 1">
          <div class="zhengshu">{{ item.value[2] }}</div>
          <div class="fenshi">
            <span class="fenzi">{{ item.value[0] }}</span>
            <p class="line"></p>
            <span class="fenmu">{{ item.value[1] }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="txt_question"
      v-show="datas.type === 'txtquestion' && questionShow"
    >
      <div class="txtinput">
        <text-area
          :placeholder="hint"
          :disabled="!a_on_off"
          @selfFocus="hint = ''"
          @selfBlur="hint = '可输入50个字噢～'"
          @selfInput="selfInput"
          @enter="enter"
          ref="textarea"
        />
        <button
          class="cursor"
          @click="enter"
          :class="{ disabled: sendText.replace(/\s/g, '').length === 0 }"
        >
          发送
        </button>
        <p>Enter发送 / Ctrl+Enter换行</p>
      </div>
    </div>
    <!--填空题显示隐藏-->
    <div
      class="hide-btn cursor"
      @click="hideQuestion"
      :class="{ 'show-btn': !questionShow }"
      v-if="datas.type === 'tiankong'"
    ></div>
    <!--选择题显示隐藏-->
    <div
      class="whl-hide-xuanze-btn cursor"
      @click="hideChooseQuestion"
      :class="{ 'whl-show-xuanze-btn': !chooseQuestionShow }"
      v-if="datas.type === 'xuanze'"
    ></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import textarea from '../textarea.vue';
export default {
  components: {
    'text-area': textarea,
  },
  props: {
    datas: {
      //渲染题目数据集合
      type: Object,
      required: false,
    },
    value: {
      //填空题中间区域返回数据集合
      type: Object,
      default: function () {
        return {
          type: 'number',
          list: [''],
        };
      },
    },
    a_on_off: {
      default: false,
    },
    k_on_off: {
      default: false,
    },
  },
  data() {
    return {
      startTime: 0,
      clickIndex: -1,
      sendText: '',
      questionShow: true,
      chooseQuestionShow: true,
      hint: '可输入50个字噢～',
      // 快速问答和标准问答选择题按钮背景
      background: '',
      backgroundDefault: require('../../../../assets/img/video/xuanze-nomal.png'),
      radicalBg: '',
      radicalDefaultBg: require('../../../../assets/img/video/genhao-hui.png'),
    };
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.initXuanzeBg();
    });
  },
  watch: {
    a_on_off(val) {
      if (val) {
        this.clickIndex = -1;
        this.showT();
      }
      if (!val && this.datas.type === 'txtquestion') {
        this.$refs.textarea.text = '';
        this.sendText = '';
        this.$refs.textarea.isScroll = false;
      }
    },
    datas: {
      deep: true,
      handler(newV, oldV) {
        this.initXuanzeBg();
      },
    },
  },
  methods: {
    // 重新设置选择题背景参数才能生效
    setBackgroundCommon(index) {
      this.$refs.xuanze[index].style.backgroundSize = 'contain';
      this.$refs.xuanze[index].style.backgroundPosition = 'center';
      this.$refs.xuanze[index].style.backgroundRepeat = 'no-repeat';
    },
    // 初始化选择题背景
    initXuanzeBg() {
      // console.log('answer-data', JSON.stringify(this.datas))
      if (JSON.stringify(this.datas) != '{}') {
        if (JSON.stringify(this.datas.current_question_style) != '{}') {
          this.background = `url(${this.datas.current_question_style.urlStuDefault}) no-repeat center/contain`;
          let urlSquareRootBg =
            this.datas.current_question_style.urlSquareRootBg;
          urlSquareRootBg = urlSquareRootBg
            ? urlSquareRootBg
            : this.radicalDefaultBg;
          this.radicalBg = `url(${urlSquareRootBg}) left top / cover no-repeat`;
        } else {
          setTimeout(() => {
            for (let index in this.datas.list) {
              this.$refs.xuanze[
                index
              ].style.background = `url(${this.backgroundDefault})`;
              this.radicalBg = `url(${this.radicalDefaultBg}) left top / cover no-repeat`;
              this.setBackgroundCommon(index);
            }
          });
        }
      }
    },
    // 选择题鼠标移入
    questionOver(currentQuestionStyle, index) {
      if (JSON.stringify(currentQuestionStyle) != '{}') {
        this.$refs.xuanze[
          index
        ].style.background = `url(${currentQuestionStyle.urlStuSelected})`;
      } else {
        this.$refs.xuanze[index].style.background =
          'url(' +
          require('../../../../assets/img/video/xuanze-check.png') +
          ')';
      }
      this.setBackgroundCommon(index);
    },
    // 选择题鼠标移出
    questionLeave(currentQuestionStyle, index) {
      if (JSON.stringify(currentQuestionStyle) != '{}') {
        this.$refs.xuanze[
          index
        ].style.background = `url(${currentQuestionStyle.urlStuDefault})`;
      } else {
        this.$refs.xuanze[
          index
        ].style.background = `url(${this.backgroundDefault})`;
      }
      this.setBackgroundCommon(index);
    },
    // 获取字体颜色
    getFontColor(currentQuestionStyle) {
      return JSON.stringify(currentQuestionStyle) != '{}'
        ? currentQuestionStyle.fontColor
        : '#fff';
    },
    // percent : 宽:高 系数
    getHeight(currentQuestionStyle) {
      //
      return JSON.stringify(currentQuestionStyle) != '{}'
        ? 220 / currentQuestionStyle.percent + 'px'
        : 136 + 'px';
    },
    // 获取最外层盒子高度
    getAnswerHeight(currentQuestionStyle) {
      if (JSON.stringify(this.datas) != '{}') {
        if (this.datas.type != 'xuanze' || !this.chooseQuestionShow) {
          return 'auto';
        } else {
          return JSON.stringify(currentQuestionStyle) != '{}'
            ? 220 / currentQuestionStyle.percent + 'px'
            : 150 + 'px';
        }
      }
    },
    // 隐藏填空题
    hideQuestion() {
      this.questionShow = !this.questionShow;
      this.dati_tk(false);
    },
    // 隐藏选择题
    hideChooseQuestion() {
      this.chooseQuestionShow = !this.chooseQuestionShow;
    },
    showT() {
      this.startTime = Date.now();
      this.$root.eventHub.$off('sure');
      this.$root.eventHub.$on('sure', () => {
        this.sure();
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventShowQuestion',
        data: {
          unique_id: this.datas.desc.recv_unique_id,
          question_id: this.datas.desc.quick_question_id,
          reffer: this.datas.desc.answer_type,
        },
      });
    },
    formatResult() {
      let result1 = '';
      let obj = this.datas.desc;
      console.log('let obj = this.datas.desc;',obj,this.startTime)
      obj.use_time = parseInt((Date.now() - this.startTime) / 1000);
      console.log('obj.use_time',obj.use_time)
      if (this.value.type == 'number') {
        result1 = this.value.list[0];
      } else if (this.value.type == 'genhao') {
        result1 = this.value.list[1] + '@' + this.value.list[0] + '@';
      } else if (this.value.type == 'pingfang') {
        result1 = this.value.list[0] + '*' + this.value.list[1] + '*';
      } else if (this.value.type == 'fenshu') {
        if (this.value.list.length == 2) {
          result1 = '#' + this.value.list[0] + '/' + this.value.list[1] + '#';
        } else {
          result1 =
            '#' +
            this.value.list[2] +
            '|' +
            this.value.list[0] +
            '/' +
            this.value.list[1] +
            '#';
        }
      }
      console.log(408)
      obj.answer = result1;
      return obj;
    },
    getMaxSize(arr) {
      let flag = arr.some((value) => {
        // console.log('value',value)
        return this.calculatefontSize(value) == 18;
      });
      return flag ? 18 : 30;
    },
    calculatefontSize(data) {
      let length = 0;
      data.forEach((item) => {
        if (item.type == 0) {
          length += this.getCharLength(item.value[0]);
        } else if (item.type == 1) {
          item.value[2] && (length += this.getCharLength(item.value[2]));
          length += Math.max(
            this.getCharLength(item.value[0]),
            this.getCharLength(item.value[1]),
          );
        } else if (item.type == 2) {
          length += this.getCharLength(item.value[1]);
        } else if (item.type == 3) {
          length += this.getCharLength(item.value[0]);
        }
      });

      return length > 8 ? 18 : 30;
    },
    /*计算填空题字符长度*/
    getCharLength(str) {
      var len = 0;
      str = new String(str);
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
          len += 2;
        } else {
          len++;
        }
      }
      return len;
    },
    sure() {
      console.log(453,this.formatResult())
      this.$emit('sure', this.formatResult());
    },
    enter(txt) {
      let obj = this.datas.desc;
      obj.use_time = parseInt((Date.now() - this.startTime) / 1000);
      obj.answer = this.$refs.textarea.text;
      this.$emit('txt_sure', obj);
      this.$refs.textarea.text = '';
      this.sendText = '';
      this.$refs.textarea.isScroll = false;
    },
    dati_tk(flag = true) {
      this.$emit('dati_tk', flag);
    },
    dati_xz(index) {
      console.log(466,'index==============')
      if (this.clickIndex != -1) return;
      this.clickIndex = index;
      let obj = this.datas.desc;
      obj.use_time = parseInt((Date.now() - this.startTime) / 1000);
      obj.answer = index + 1;
      this.$emit('dati_xz', obj);
    },
    selfInput(val) {
      this.sendText = val;
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.answer {
  width: 100%;
  position: absolute;
  bottom: 55px;
  font-family: Microsoft YaHei, '黑体', monospace, PingFang_Regular, sans-serif,
    SimHei;
  z-index: 91;
  //height: 150px;
  height: auto;
  text-align: center;

  .xuanze {
    position: absolute;
    z-index: 999;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    //height: 159px;
    height: 100%;
    min-width: 1024px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    //margin-top: 45px;

    .content {
      width: 220px;
      height: 136px;
      padding: 0 20px;
      font-size: 18px;
      color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 12;
      /*opacity: 0;*/
      transition: all 0.2s;
      animation-fill-mode: both;
      cursor: pointer;
      //background: url("../../../../assets/img/video/xuanze-nomal.png") no-repeat center 100%;
      box-sizing: border-box;
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      //选择题分式
      .fenshu {
        display: flex;
        justify-content: center;
        align-items: center;
        .fenshi {
          display: flex;
          flex-direction: column;
          line-height: 32px;
        }
        .line {
          display: block;
          height: 2px;
          background: #fff;
          width: 100%;
        }
      }
      .genhao {
        display: flex;
        justify-content: center;
        .beikaifang {
          min-width: 30px;
          display: inline-block;
          height: 33px;
          line-height: 28px;
          //margin-left: 10px;
          //background: url("../../../../assets/img/video/genhao-hui.png") no-repeat top left;
          background-repeat: no-repeat;
          background-position: top left;
          margin-top: 4px;
          padding-left: 24px;
          padding-top: 2px;
          text-align: center;
          background-size: cover;
        }
        .kaifang {
          display: inline-block;
          //transform: translateY(-14px);
          font-size: 30px;
          //margin-right: -18px;
        }
      }
      .pingfang {
        display: flex;
        .dishu {
          margin-right: -5px;
          line-height: 47px;
        }
        .mi {
          line-height: 32px;
          font-size: 14px;
          vertical-align: 13px;
          margin: 0 6px;
          margin-right: 0;
        }
      }
    }
    .content:hover {
      z-index: 15;
    }
    .content1 {
      margin-right: 40px;
    }
    .content2 {
      margin-right: 100px;
    }
    .content4 {
      margin-left: 40px;
    }
    .aaa {
      margin-right: 100px;
    }
    .bbb {
      margin-right: 0;
    }
    .ccc {
      margin-left: 200px;
    }
  }
  .tiankong {
    width: 100%;
    height: 125px;
    background: rgba(0, 0, 0, 0.8);
    line-height: 150px;
    display: flex;
    justify-content: center;
    padding-top: 18px;
    font-size: 0;
    animation-fill-mode: both;
    // transform: translateY(400px);
    .content_end,
    .content_middle {
      display: flex;
      align-items: center;
      height: 52px;
      line-height: 52px;
      color: #fff;
      font-size: 18px;
      .txt {
        display: flex;
        align-items: center;
        line-height: 1.2;
        margin: 0 5px;
      }
      .genhao {
        .beikaifang {
          min-width: 50px;
          display: inline-block;
          height: 33px;
          line-height: 28px;
          background: url('../../../../assets/img/video/genhao.png') no-repeat
            top left;
          margin-top: 4px;
          padding-left: 20px;
          padding-top: 2px;
          text-align: center;
          background-size: cover;
        }
        .kaifang {
          display: inline-block;
          transform: translateY(-14px);
          margin-right: -18px;
        }
      }
      .pingfang {
        display: flex;
        .dishu {
          margin-right: -5px;
        }
        .mi {
          line-height: 47px;
          font-size: 14px;
          vertical-align: 13px;
          margin: 0 6px;
        }
      }
      .fenshu {
        display: flex;
        justify-content: center;
        align-items: center;
        .fenshi {
          display: flex;
          flex-direction: column;
          line-height: 28px;
        }
        .line {
          display: block;
          height: 2px;
          background: #fff;
          width: 100%;
        }
      }
    }
    .content_middle {
      overflow: hidden;
      height: 52px;
      background: #fff;
      width: 140px;
      font-size: 24px;
      color: #000;
      padding: 0 4px;
      margin: 0 6px;
      border-radius: 6px;
      .default-txt {
        color: #007595;
        font-size: 20px;
        text-align: center;
        height: 100%;
        width: 100%;
        line-height: 52px;
        font-weight: 600;
      }
      .txt {
        display: inline-block;
        width: 140px;
        line-height: 52px;
        white-space: nowrap;
      }
      .genhao {
        width: 140px;
        .beikaifang {
          width: 130px;
          vertical-align: middle;
          background: url('../../../../assets/img/video/genhao1.png') no-repeat
            top left;
          background-size: cover;
        }
      }
      .fenshu {
        width: 140px;
        // .fenzi {
        //   height: 42px;
        // }
        .line {
          height: 2px;
          background: #000;
        }
      }
    }
  }
  .zoomIn {
    animation: answer-in 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
    animation-fill-mode: both;
  }
  .zoomOut {
    animation: answer-out 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
    animation-fill-mode: both;
  }

  .active {
    top: -20px;
  }

  .txt_question {
    width: 100%;
    height: 125px;
    background: rgba(0, 0, 0, 0.8);
    .txtinput {
      width: 1110px;
      margin: 0 auto;
      padding-top: 16px;
      display: flex;
    }
    button {
      width: 117px;
      height: 63px;
      background: #4277e6;
      border-radius: 6px;
      font-size: 20px;
      color: #ffffff;
      font-family: PingFang_Regular;
      margin: 0 20px;
    }
    .disabled {
      background: #454545;
      color: rgba(255, 255, 255, 0.6);
      pointer-events: none;
    }
    p {
      text-align: right;
      font-size: 14px;
      opacity: 0.6;
      color: #fff;
      font-family: PingFang_Regular;
      line-height: 63px;
    }
  }
  //快速问答选择题显示隐藏
  .whl-hide-xuanze-btn {
    width: 55px;
    height: 55px;
    position: absolute;
    left: 120px;
    top: -55px;
    background: url('../../../../assets/img/video/shouqi-icon.png') no-repeat
      center;
    background-size: 100%;
  }
  .whl-show-xuanze-btn {
    background: url('../../../../assets/img/video/xianshi-icon.png') no-repeat
      center;
    background-size: 100%;
  }
}
.answer-bottom {
  bottom: 50px;
  height: auto;
}
.hide-btn {
  width: 63px;
  height: 45px;
  position: absolute;
  right: 120px;
  top: -45px;
  background: url('../../../../assets/img/video/hide-question.png') no-repeat
    center;
  background-size: 100%;
}
.show-btn {
  background: url('../../../../assets/img/video/show-question.png') no-repeat
    center;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/answer/answer.vue